import { render, staticRenderFns } from "./subCard.vue?vue&type=template&id=6d57e6f6&scoped=true&"
import script from "./subCard.vue?vue&type=script&lang=js&"
export * from "./subCard.vue?vue&type=script&lang=js&"
import style0 from "./subCard.vue?vue&type=style&index=0&id=6d57e6f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d57e6f6",
  null
  
)

export default component.exports